import {Layers, WalkOfShameLayers} from "./WalkOfShameLayers";
import {TimelineLite} from "gsap";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {ScreenBounds} from "@nolimitcity/slot-launcher/bin/display/ScreenBounds";

export class WalkOfShameBlackOverlay extends PIXI.Container {
    private _overlay: PIXI.Graphics;

    constructor() {
        super();

        this.init();
    }

    public showOverlay(duration: number, toAlpha: number, layer: Layers): void {
        if (this._overlay.visible) {
            return;
        }

        const tl: TimelineLite = new TimelineLite();
        tl.add(() => {
            this._overlay.alpha = 0;
            this._overlay.visible = true;

            WalkOfShameLayers.getLayer(layer)?.addChild(this);
        });
        tl.to(this._overlay, {
            alpha: toAlpha,
            duration: duration
        });
    }

    public hideOverlay(duration: number): void {
        if (!this._overlay.visible) {
            return;
        }

        const tl: TimelineLite = new TimelineLite();
        tl.to(this._overlay, {
            alpha: 0,
            duration: duration
        });
        tl.add(() => {
            this._overlay.visible = false;
        });
    }

    public onOrientationChanged(): void {
        if (!this._overlay) {
            return;
        }

        const screenBounds: ScreenBounds = NolimitApplication.screenBounds;

        this._overlay.clear();
        this._overlay.beginFill(0x000000, 1);
        this._overlay.drawRect(screenBounds.left, screenBounds.top - 20, screenBounds.width, screenBounds.height + 40);
        this._overlay.endFill();
    }

    private init(): void {
        this._overlay = new PIXI.Graphics();
        this._overlay.visible = false;

        this.onOrientationChanged();
        this.addChild(this._overlay);
    }
}